import { Box, Center, Heading, Text } from "@chakra-ui/react";
import BranchServicesTable from "../tables/BranchServicesTable";
import { useSelector } from "react-redux";
import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import _ from "lodash";
import { checkServiceHasChildren, mapHasData } from "../../../store/helpers";

const BranchServices = ({ data, branchId, reportIndex, branchIndex }) => {

  const { branches, servicesSubscriptions, services } = useSelector(
    (state) => state.defaultReducer
  );
  const servicesClone = _.cloneDeep(services);

  const servicesSubscriptionsClone = _.cloneDeep(servicesSubscriptions);
  let branchServices = servicesSubscriptionsClone.find(
    (service) => service.branchId === branchId
  )?.services;

  branchServices = checkServiceHasChildren(servicesClone)
    .filter(
      (service) => branchServices?.includes(service.id) && !service.hasChildren
    )
    .map((service) => service.id);

  const servicesMap = {};
  branchServices.forEach((serviceId) => {
    servicesMap[serviceId] = [];
  });

  // Iterate over the data array and group objects by serviceId
  data.forEach((item) => {
    const serviceId = item.serviceId;

    if (Array.isArray(servicesMap[serviceId])) {
      servicesMap[serviceId].push(item);
    }
  });

  const branchName =
    branches.find((branch) => branch.id === branchId)?.name ||
    `Branch-${branchId}`;

  const title = `${reportIndex || ""}.${branchIndex + 1}. ${branchName}`;

  return (
    <Box>
      <h2>
        {title}
      </h2>
      {!mapHasData(servicesMap) && <Text fontSize="sm">No data available for this report</Text>}
      <Text>{branchServices.length} services.</Text>

      {mapHasData(servicesMap) &&
        Object.entries(servicesMap).map(([key, value], index) => {
          return (
            <BranchServicesTable
              index={index}
              branchIndex={branchIndex}
              reportIndex={reportIndex}
              branchName={branchName}
              key={key}
              serviceId={key}
              data={value}
              frequency={ARRIVAL_RATES_FREQUENCIES.DAY}
            />
          );
        })}
    </Box>
  );
};

export default BranchServices;
